import { render, staticRenderFns } from "./SerumProductDescription.vue?vue&type=template&id=e2fc87fe&scoped=true&"
import script from "./SerumProductDescription.vue?vue&type=script&lang=js&"
export * from "./SerumProductDescription.vue?vue&type=script&lang=js&"
import style0 from "./SerumProductDescription.vue?vue&type=style&index=0&id=e2fc87fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fc87fe",
  null
  
)

export default component.exports